"use client"

import { ListX } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `ListXIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const ListXIcon = component(Icon)({ as: ListX })
